import { useMemo } from 'react';
import { useConfig } from '../context';
export const useCityOptions = (options) => {
    const { SearchForm: { locationGroups } } = useConfig();
    const [additionalOptions, otherOptions] = useMemo(() => {
        const additionalOptions = [];
        const otherOptions = [];
        options.forEach(option => {
            if ('type' in option && locationGroups.additionalGroupTypes.includes(option.type)) {
                additionalOptions.push(option);
            }
            else {
                otherOptions.push(option);
            }
        });
        return [additionalOptions, otherOptions];
    }, [options]);
    const dropdownOptions = locationGroups.showAdditionalGroups && additionalOptions.length
        ? [...additionalOptions, ...(options.length < 4 ? otherOptions : [])]
        : otherOptions;
    const showAdditionalButton = dropdownOptions.length <
        [...otherOptions, ...(locationGroups.showAdditionalGroups ? additionalOptions : [])].length;
    return { dropdownOptions, showAdditionalButton };
};
